/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EpisodeAccessModel } from './EpisodeAccessModel';
import {
    EpisodeAccessModelFromJSON,
    EpisodeAccessModelFromJSONTyped,
    EpisodeAccessModelToJSON,
} from './EpisodeAccessModel';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { UserModel } from './UserModel';
import {
    UserModelFromJSON,
    UserModelFromJSONTyped,
    UserModelToJSON,
} from './UserModel';

/**
 * 作品内の1エピソードの概要(題名やサムネイル画像など)を表します。
 * 
 * エピソード内の完全な情報は、この中に含まれるURLから取得可能です。
 * @export
 * @interface EpisodeSummaryModel
 */
export interface EpisodeSummaryModel {
    /**
     * コミチ内におけるエピソードの一意のID
     * @type {string}
     * @memberof EpisodeSummaryModel
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EpisodeSummaryModel
     */
    indexId?: number;
    /**
     * このエピソードの題名
     * @type {string}
     * @memberof EpisodeSummaryModel
     */
    title: string;
    /**
     * このエピソードの完全な情報を取得可能なURL
     * @type {string}
     * @memberof EpisodeSummaryModel
     */
    url: string;
    /**
     * 
     * @type {UserModel}
     * @memberof EpisodeSummaryModel
     */
    author?: UserModel;
    /**
     * このエピソードが公開された日時のUNIX時間
     * @type {number}
     * @memberof EpisodeSummaryModel
     */
    datePublished?: number;
    /**
     * エピソードのいいね数
     * @type {number}
     * @memberof EpisodeSummaryModel
     */
    numLikes?: number;
    /**
     * サムネイル画像
     * 幅の大きい順で、複数の画像が含まれる場合が有ります。
     * @type {Array<ImageModel>}
     * @memberof EpisodeSummaryModel
     */
    thumbnailImages?: Array<ImageModel>;
    /**
     * 
     * @type {EpisodeAccessModel}
     * @memberof EpisodeSummaryModel
     */
    access?: EpisodeAccessModel;
}

/**
 * Check if a given object implements the EpisodeSummaryModel interface.
 */
export function instanceOfEpisodeSummaryModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function EpisodeSummaryModelFromJSON(json: any): EpisodeSummaryModel {
    return EpisodeSummaryModelFromJSONTyped(json, false);
}

export function EpisodeSummaryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpisodeSummaryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'indexId': !exists(json, 'indexId') ? undefined : json['indexId'],
        'title': json['title'],
        'url': json['url'],
        'author': !exists(json, 'author') ? undefined : UserModelFromJSON(json['author']),
        'datePublished': !exists(json, 'datePublished') ? undefined : json['datePublished'],
        'numLikes': !exists(json, 'numLikes') ? undefined : json['numLikes'],
        'thumbnailImages': !exists(json, 'thumbnailImages') ? undefined : ((json['thumbnailImages'] as Array<any>).map(ImageModelFromJSON)),
        'access': !exists(json, 'access') ? undefined : EpisodeAccessModelFromJSON(json['access']),
    };
}

export function EpisodeSummaryModelToJSON(value?: EpisodeSummaryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'indexId': value.indexId,
        'title': value.title,
        'url': value.url,
        'author': UserModelToJSON(value.author),
        'datePublished': value.datePublished,
        'numLikes': value.numLikes,
        'thumbnailImages': value.thumbnailImages === undefined ? undefined : ((value.thumbnailImages as Array<any>).map(ImageModelToJSON)),
        'access': EpisodeAccessModelToJSON(value.access),
    };
}

